import { render } from "./UserTextResponse.vue?vue&type=template&id=24661e66&scoped=true"
import script from "./UserTextResponse.js?vue&type=script&lang=js&external"
export * from "./UserTextResponse.js?vue&type=script&lang=js&external"

import "./UserTextResponse.vue?vue&type=style&index=0&id=24661e66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24661e66"]])

export default __exports__